import { ValuableNode } from '../../models/ValuableNode'

export class SchemaNullNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Null': SchemaNullNode
  }
}
